module.exports = __webpack_public_path__ + "static/img/Logo MoviWearMed.a3a75a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Logo MoviWearMed.png
// module id = Ndjq
// module chunks = 7